/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2026 (original work) Open Assessment Technologies SA ;
 */

import config from '@/config';
import { multiGuard } from '@/core/guards/guardComposer.js';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';
import { getFeaturesGuard } from '@/core/guards/featureFlagGuard.js';
import { FEATURE_PROCTORING_REVIEW } from '@/constants/features.js';

export const routing = [
    {
        path: [config.routes.proctoringReview.export],
        guard: multiGuard([
            getFeaturesGuard(FEATURE_PROCTORING_REVIEW),
            getPermissionsGuard([{ resource: 'portal.proctoring-review', scopes: ['manage'] }])
        ]),
        controller: () => import('./controllers/proctoringReviewExport.controller.js')
    }
];
